/**
 * Private modules
 */
const {
  compositeKey,
  createQueryComponent,
  customerId,
  customerSystemTicketNumberPluginId,
  model,
  multiplier,
  number,
  systemGameCategoryId,
  systemGameId,
} = require('../.private').components;

/**
 * Scopes
 */
const { DEFAULT } = require('../../scopes');

module.exports = {
  deleteCustomerRequestLimitsBySystemGameId: {
    properties: {
      body: {
        properties: {
          models: {
            items: model,
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
        },
        required: ['models'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getCustomerRequestLimitPackageByCompositeKey: {
    properties: {
      params: {
        properties: {
          compositeKey,
          customerId,
        },
        required: [
          'compositeKey',
          'customerId',
        ],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  getCustomerRequestLimitsBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent([DEFAULT]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  saveCustomerRequestLimitsBySystemGameId: {
    properties: {
      body: {
        properties: {
          customerSystemTicketNumberPluginId,
          elements: {
            items: {
              properties: {
                multiplier,
                systemGameCategoryId,
              },
              required: [
                'multiplier',
                'systemGameCategoryId',
              ],
              type: 'object',
            },
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
          number,
        },
        required: [
          'customerSystemTicketNumberPluginId',
          'elements',
          'number',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
